var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "seo-text" }, [
    _vm.seoTextMainHeadline != ""
      ? _c("div", { staticClass: "seo-text__main-headline" }, [
          _vm._v(_vm._s(_vm.seoTextMainHeadline))
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      ref: "collapsableText",
      staticClass: "seo-text__collapsable",
      domProps: { innerHTML: _vm._s(_vm.seoText) }
    }),
    _vm._v(" "),
    _vm.seoText.length > 0
      ? _c(
          "a",
          {
            staticClass: "seo-text__collapse-toggle",
            attrs: { href: "#" },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.toggleText()
              }
            }
          },
          [_vm._v(_vm._s(_vm.$translate("ODStylebreaker::Template.showMore")))]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }